import {Component, ElementRef, OnInit, ViewChildren, ViewEncapsulation} from "@angular/core";
import {ConversationService} from "../../Services/conversationService";
import {DTOConversation, DTOConversationMessage} from "../../api/WickedApiClient";
import {MainService} from "../../Services/service.service";
import {ConfirmationResult} from "../../Messages/confirm-sheet/confirmation-sheet.component";
import {NgxGalleryAnimation, NgxGalleryImage, NgxGalleryOptions} from "ngx-gallery";
import {SendConversationMessageComponent} from "../../Components/send-message/send-conversation-message.component";
import {Router, ActivatedRoute, Params} from "@angular/router";
import {MatCardXlImage, MatCheckbox} from "@angular/material";
import {environment} from "src/environments/environment";


@Component({
  selector: 'conversation-list',
  styleUrls: ['./conv-list.component.scss'],
  templateUrl: "./conv-list.component.html",
  encapsulation: ViewEncapsulation.None
})
export class ConversationsListComponent implements OnInit {


  @ViewChildren('convList', {read: ElementRef}) convList;
  @ViewChildren('checboxList') checboxList;

  private _conversationService: ConversationService;

  private activeConversationId: string;

  public perPage: number = 24; //count convs per page 0 is for all
  public page: number = 0;

  loading: boolean = false;
  noConversationsInfo: boolean = false;

  public refreshingLastList: boolean = false

  constructor(public mainService: MainService, conversationService: ConversationService, private router: Router, private route: ActivatedRoute) {
    this.activeConversationId = this.route.snapshot.paramMap.get('id');

    this.route.queryParams.subscribe(params => {
      let paramPage = (isNaN(params['page']) ? 1 : params['page']);
      paramPage = paramPage<=0? 1 : paramPage;
      this.page = Number(paramPage)-1;
      let paramPerPage = (isNaN(params['perPage']) ? 24 : params['perPage']);
      if (paramPerPage) this.perPage = Number(paramPerPage);
      else this.perPage = 24;
    });

    //if(this.activeConversationId) this.perPage = 0;

    this._mainService = mainService;
    this._conversationService = conversationService;
  }

  private _currentUserIsAdmin: boolean = false;

  conversations: DTOConversation[] = [];
  images: {} = {};

  private _mainService: MainService;
  private userNick: number;

  ngOnInit(): void {
    this.userNick = this._mainService.userService.getUserId();
    this._currentUserIsAdmin = this._mainService.userService.isAdmin();
    const lastConversations = this._conversationService.getLastConversations();
    if(lastConversations && !this.activeConversationId) {
      this.refreshingLastList = true;
      this.conversations = lastConversations;
      this.reloadConversations(false);
    } else {
      this.reloadConversations();
    }
    this._conversationService.getConversationsCount().then(result => {
      this._allConversationsCount = result;
    })
  }
  ngAfterViewInit() {
    this.convListArray = this.convList.toArray();
    this.convList.changes.subscribe(t => {
      this.ngForRendred();
    })
    this.checboxList.changes.subscribe(t => {
      this.ngForRendredChecboxes();
    })
  }

  ngForRendred() {
    this.convListArray = this.convList.toArray();
  }
  ngForRendredChecboxes() {
    this.checboxListArray = this.checboxList.toArray();
  }

  public galleryOptions: NgxGalleryOptions[] = [
    {
      thumbnailsColumns: 6,
      width: "400px",
      imageSize: 'Contain',
      imageAnimation: NgxGalleryAnimation.Slide,
      thumbnailsAutoHide: true
    },
    // max-width 800
    {
      breakpoint: 1200,
      thumbnailsColumns: 5,
    },
  ];

  private _pageEvent;
  public get pageEvent() {
    return this._pageEvent;
  }

  public set pageEvent(value) {
    this._pageEvent = value;
    this.page = value.pageIndex;
    this.addUrlPageParam(value.pageIndex + 1);
    this.reloadConversations();
  }
  private pageChange(e) {
    window.scroll(0, 0);
  }

  private addUrlPageParam(value) {
    const queryParams: Params = {page: value};

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  private _allConversationsCount: number = 0;

  public get allConversationsCount() {
    return this._allConversationsCount;
  }

  private reloadConversations(loading = true) {

    this.loading = loading;
    this._conversationService.getConversations(this.perPage, this.page).then(result => {
      this.loading = false;
      this.noConversationsInfo = (result.conversations == null || result.conversations.length == 0);
      this.conversations = result.conversations;

      this.conversations.forEach((conversation) => {
        conversation.messages.forEach((message) => {
          if(message.images.length > 0) {
            if(this.images[conversation.conversationId] == null) {
              this.images[conversation.conversationId] = {}
            }
            this.images[conversation.conversationId][message.conversationMessageId] = this.prepareImages(message);
          }
        })
      });
      this.refreshingLastList = false;
    }).catch(error => {
      this.loading = false;
      this._mainService.showError(error)
    })
  }

  hasImages(conversationIndex: number, messageIndex: number): boolean {
    return this.images[conversationIndex] != null && this.images[conversationIndex][messageIndex] != null && this.images[conversationIndex][messageIndex].length > 0;
  }

  clearTitle(title: string) {
    const regex = /\[[A-Z0-9]{10}]/;
    return title.replace(regex, '');
  }

  prepareImages(message: DTOConversationMessage): {small: string, medium: string, big: string}[] {
    var images = message.images.map(img => {
      return {
        small: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        medium: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        big: `${environment.apiBaseUrl}/FileGet/${img.fileName}`
      }
    });

    return images;
  }

  sendConversationMessage(messageComponent: SendConversationMessageComponent, conversationId: number) {
    const messageParams = messageComponent.prepareMessageParams();
    messageComponent.submitStart();
    this._conversationService.sendMessageToExistingConversation(
      this._mainService.userService.getUserId(), messageParams.content,
      messageComponent.currentConversation!!.conversationId,
      messageParams.images).then(result => {

        this._conversationService.getConversation(conversationId).then(conversation => {
          messageComponent.submitFinished();
          let thanksInfo = this._mainService.showInformation("Your message has been sent");
          setTimeout(() => {
            thanksInfo.dismiss();
            let conversationIndex = this.conversations.findIndex(c => c.conversationId == conversationId);
            if(conversationIndex > -1) {

              let img = {};
              conversation.messages.forEach((message, messageIndex) => {
                if(message.images.length > 0) {
                  img[message.conversationMessageId] = this.prepareImages(message);
                }
              })
              this.images[conversationId] = img;
              this.conversations[conversationIndex].messages = conversation.messages;

            }
          }, 2000);
          messageComponent.clear();


        });


      }
      ).catch(
        err => {
          this._mainService.showError(err);
          messageComponent.submitFinished();
        }
      )


  }



  showDemoAdInfo(conversation: DTOConversation) {
    return conversation.demoAdvertisement && this._currentUserIsAdmin;
  }

  resolveConversationSenderNick(conversation: DTOConversation) {
    if(conversation.senderId == this.userNick) {
      return "You"
    }
    else return conversation.senderNick;
  }

  resolveMessageSenderNick(conversation: DTOConversation, message: DTOConversationMessage) {
    if(message.senderId == this._mainService.userService.getUserId()) {
      return "You"
    }
    else {
      if(conversation.senderId == message.senderId) {
        return conversation.senderNick
      }
      else return conversation.receiverNick;
    }
  }

  public hasNewMessages(conversation: DTOConversation): boolean {
    var userId = this._mainService.userService.getUserId();
    return conversation.messages.filter(m => !m.isRead && m.senderId != userId).length > 0;
  }

  setUrlId(id) {
    this.activeConversationId = id;
    const newUrl = "conversations/" + id;
    window.history.pushState({pageTitle: "conversations"}, "", newUrl);
  }

  setReadedMessages(conversation: DTOConversation): void {
    this._conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(c => c.conversationMessageId)).then((r) => {
      if(r) {
        conversation.hasNewMessages = false;
      }
    });
  }

  private _selectedConvCount: number = 0;
  private convListArray: Array<ElementRef> = [];
  private checboxListArray: Array<MatCheckbox> = [];
  public selectAllCheckbox = false;

  get selectedConvCount() {
    //this._selectedConvCount = document.getElementsByClassName("isSelected").length;
    this._selectedConvCount = 0
    this.checboxListArray.forEach(e => {
      if(e['checked'] == true) {
        this._selectedConvCount++
      }
    });
    return this._selectedConvCount;
  }

  deleteConversation(conversationId: number, arrayIndex: number) {
    this._mainService.showConfirm("Are you sure?", "300px").then((res) => {
      if(res == ConfirmationResult.Yes) {
        const thisConvElement = document.getElementsByClassName('conversation-' + conversationId)[0];
        thisConvElement.classList.add("deleting");
        this._conversationService.deleteConversation(conversationId, arrayIndex).then(res => {
          this._mainService.showInformation("Conversation deleted");
          thisConvElement.remove();
        }).catch(err => {
          this._mainService.showError(err)
        })
      }


    })
  }

  selectAllConversations(e) {
    if(e.checked) {
      this.convListArray.forEach(e => {
        e.nativeElement.classList.add('isSelected');
        e.nativeElement.classList.add('showChecbox');
      });
      this.checboxListArray.forEach(e => {
        e['checked'] = true;
      });

    } else {
      this.convListArray.forEach(e => {
        e.nativeElement.classList.remove('isSelected');
      });
      this.checboxListArray.forEach(e => {
        e['checked'] = false;
      });
    }
  }
  selectConversation(e, i) {
    const convClassList = this.convListArray[i].nativeElement.classList;
    if(e.checked) {
    } else {
    }
    convClassList.toggle('isSelected');
    if(this.selectedConvCount == this.convListArray.length) {
      this.selectAllCheckbox = true;
    } else {
      this.selectAllCheckbox = false;
    }
  }

  deleteSelectedConv() {
    this._mainService.showConfirm("Are you sure to delete " + this.selectedConvCount + " conversations ?", "300px").then((res) => {
      if(res == ConfirmationResult.Yes) {
        this.loading = true;
        let tmpDeletedCount = 0;
        this.checboxListArray.forEach(e => {
          if(e['checked']) {
            this._conversationService.deleteConversation(parseInt(e.id)).then(res => {
              tmpDeletedCount++;
              if(this.selectedConvCount == tmpDeletedCount) {
                this._mainService.showInformation("Conversations deleted");
                this.reloadConversations();
              }
            }).catch(err => {
              this._mainService.showError(err)
            })
          }
        });
      }
    })
  }

  restoreConvMsgs() {
    this._conversationService.restoreConversationsHasMessages();
  }
}
